var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-content"},[_c('div',{staticClass:"content-area"},[_c('div',{staticClass:"container-fluid"},[(_vm.isLoggedIn)?_c('router-view',{key:_vm.$route.fullPath},[_vm._v("Loading...")]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }